import React from 'react';
import {Divider as VWDivider} from '@volkswagen-onehub/components-core';

export function Divider(): JSX.Element {
  return <VWDivider />;
}
